"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const dishes = [{
  id: 1,
  title: "Residential Moving",
  description: "Stress-free home relocations with expert packing and careful handling of your most precious belongings.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/residential_moving_service.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/residential_moving_service.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/residential_moving_service.png-wvc-sizes"
  },
  link: "/GetQuotePage"
}, {
  id: 2,
  title: "Commercial Logistics",
  description: "Efficient office and business transitions designed to minimize downtime and maximize productivity.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/commercial_office_relocation.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/commercial_office_relocation.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/commercial_office_relocation.png-wvc-sizes"
  },
  link: "/GetQuotePage"
}, {
  id: 3,
  title: "Specialized Transport",
  description: "White-glove service for fragile items, pianos, and high-value equipment requiring custom crating.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/specialized_fragile_handling.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/specialized_fragile_handling.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/specialized_fragile_handling.png-wvc-sizes"
  },
  link: "/GetQuotePage"
}, {
  id: 4,
  title: "Packing Solutions",
  description: "Professional grade materials and techniques to ensure every item is secured for the journey ahead.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/professional_packing_supplies.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/professional_packing_supplies.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/professional_packing_supplies.png-wvc-sizes"
  },
  link: "/ResourcesPage"
}, {
  id: 5,
  title: "Secure Storage",
  description: "Climate-controlled, 24/7 monitored facilities for short-term or long-term storage needs.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/secure_storage_facility.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/secure_storage_facility.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/secure_storage_facility.png-wvc-sizes"
  },
  link: "/GetQuotePage"
}, {
  id: 6,
  title: "Interstate Transit",
  description: "Seamless long-distance moving with real-time tracking and dedicated logistics coordination.",
  image: {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/interstate_moving_truck.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/interstate_moving_truck.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/interstate_moving_truck.png-wvc-sizes"
  },
  link: "/GetQuotePage"
}];
export default function RelocationSolutions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="265034" id="relocation-solutions" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-5 mix-blend-overlay bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685917/img/grid_blueprint_texture.png)] bg-cover bg-center bg-fixed" aria-hidden="true" />

      <div className="container mx-auto px-4 relative z-10">
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-secondary mb-6 tracking-tighter uppercase">
            Relocation Solutions
          </h2>
          <p className="text-lg md:text-xl text-foreground/80 font-default max-w-2xl mx-auto">
            Precision-engineered moving services tailored to your specific needs. We handle the heavy lifting so you can focus on your next chapter.
          </p>
        </div>

        {}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
          {dishes.map((dish, i) => <Card key={dish.id} data-index={i} className="p-0 border border-border overflow-hidden group relative break-inside-avoid rounded-lg shadow-md bg-card transition-all duration-300 hover:shadow-xl">
              <div className="relative w-full aspect-[4/5] md:aspect-auto md:h-[450px]">
                <img src={dish.image.src} data-wvc-srcset={dish.image.srcset} data-wvc-sizes={dish.image.sizes} alt={dish.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover grayscale transition-all duration-700 ease-out group-hover:grayscale-0 group-hover:scale-105" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-secondary/95 via-secondary/40 to-transparent transition-opacity duration-500 group-hover:opacity-80" />
                
                <CardContent className="absolute inset-0 p-6 md:p-8 flex flex-col justify-end">
                  <CardTitle className="text-white font-serif text-2xl md:text-3xl mb-2 drop-shadow-lg uppercase tracking-tight">
                    {dish.title}
                  </CardTitle>
                  
                  <div className="overflow-hidden">
                    <div className="opacity-0 translate-y-8 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 ease-out flex flex-col gap-5">
                      <p className="text-white/90 text-sm md:text-base font-default leading-relaxed">
                        {dish.description}
                      </p>
                      <div>
                        <Button asChild variant="outline" className="border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all duration-300 rounded-md">
                          <Link to={dish.link}>
                            Learn More <ArrowRight className="ml-2 size-4 transition-transform duration-300 group-hover:translate-x-1" />
                          </Link>
                        </Button>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}